module.exports = __webpack_public_path__ + "static/media/family_05.8690ea07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/family/JPEG/family_05.jpg
// module id = 5837
// module chunks = 0